import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { DatePicker, getISODate, LoadingPage, Nodata, useAuth } from "../sdk";
import { useLeadTimePricing } from "./hooks/useLeadTimePricing";
import { Page, Body, Header, SubHeader } from "./Styles";
import LeadTimePricingChart from "./components/LeadTimePricingChart";
import LeadTimePricingTable from "./components/LeadTimePricingTable";
import { Label } from "../CompetitorPricing/Styles";

const parseDateFromParam = (dateParam) => {
  if (!dateParam) return null;

  const date = new Date(dateParam);
  return isNaN(date.getTime()) ? null : date;
};

const getDefaultDate = () => {
  const today = new Date();
  today.setDate(today.getDate() - 1);
  return today;
};

export default function LeadTimePricing({ setPageHeader }) {
  const { hotelId, DATE } = useParams();
  const history = useHistory();
  const { token } = useAuth();

  const [selectedDate, setSelectedDate] = useState(
    () => parseDateFromParam(DATE) || getDefaultDate(),
  );

  const { fetchLeadTimePricing, leadTimeData, isLoading } = useLeadTimePricing(
    selectedDate,
  );

  // Set page header
  useEffect(() => {
    setPageHeader("Lead Time Pricing");
    return () => setPageHeader("");
  }, [setPageHeader]);

  // Sync URL with state changes
  useEffect(() => {
    if (!hotelId || !token) return;

    const dateString = getISODate(selectedDate).split("T")[0];
    history.replace(
      `/hotel/${hotelId}/analytics/lead_time_pricing/${dateString}`,
    );
  }, [selectedDate, hotelId, token, history]);

  useEffect(() => {
    if (!token || !hotelId || !selectedDate) return;

    fetchLeadTimePricing();
  }, [token, hotelId, selectedDate, fetchLeadTimePricing]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  return (
    <Page>
      <Body>
        <Header>
          <SubHeader>
            <Label>Lead Time For: </Label>
            <DatePicker
              inputFormat={"dd/MM/yyyy"}
              date={selectedDate}
              onChange={handleDateChange}
            />
          </SubHeader>
        </Header>

        {isLoading ? (
          <LoadingPage />
        ) : leadTimeData && leadTimeData.length > 0 ? (
          <>
            <LeadTimePricingChart data={leadTimeData} />
            <LeadTimePricingTable data={leadTimeData} />
          </>
        ) : (
          <Nodata
            message={"There is no data available for the selected date."}
          />
        )}
      </Body>
    </Page>
  );
}
